import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { GiftShop_Info } from '../../generated/mlmbox/types/gift_shop';

import { useNavigate, useParams } from 'react-router';
import { Status_Transaction } from '../../generated/mlmbox/types/status';
import { getCard, reviewCard } from '../../shared/api/market/card';
import Loader from '../../shared/ui/Loader/Loader';
import PageHeader from '../../shared/ui/PageHeader/PageHeader';
import MessageStick from '../../shared/ui/MessageStick/MessageStick';
import ShodawButton from '../../shared/ui/ShadowButton/ShodawButton';
import { camB, checkW } from '../../assets';
import styles from './Review.module.scss';

const Review: FC = () => {
    const { cardId } = useParams();
    const [card, setCard] = useState<GiftShop_Info>();
    const [link, setLink] = useState('');
    const [pending, setPending] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!cardId) return;

        getCard(Number(cardId))
            .then((res) => {
                if (res) {
                    if (res.card && res.card.transaction?.statusId !== Status_Transaction.SUCCESS) return navigate(`/card/${cardId}`);
                    setCard(res);
                } else navigate(`/card/${cardId}`);
            })
            .catch((e) => {
                console.log(e);
                navigate(`/card/${cardId}`);
            });
    }, []);

    async function handleClick() {
        if (!link || !card?.card) return;
        setPending(true);

        const response = await reviewCard({ cardId: card?.card?.id, videoUrl: link });

        if (!response) {
            setPending(false);
            message.error('Ошибка при сохранении');
            return;
        }

        navigate(`/card/${card.card.id}`);
    }

    return (
        <>
            {pending && (
                <div className="dis">
                    <Loader />
                </div>
            )}

            <div className={styles.review}>
                <>
                    {card?.card && (
                        <div className="start">
                            <PageHeader
                                title={t('rew')}
                                closeBtn={() => navigate(`/card/${card?.card?.id}`)}
                            />
                            <div className={styles.cont}>
                                {' '}
                                <input
                                    placeholder="Вставьте ссылку на ролик с отзывом"
                                    type="text"
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                />
                                <MessageStick
                                    icon={camB}
                                    title="Запишите видео отчет о получении подарка и загрузите его на YouTube или Vimeo"
                                    bg="rgba(0, 122, 255, 0.05)"
                                />
                            </div>

                            <ShodawButton
                                style={{ opacity: link ? 1 : 0.5 }}
                                shadow
                                title={t('btns.save')}
                                icon={checkW}
                                onClick={handleClick}
                            />
                        </div>
                    )}
                </>
            </div>
        </>
    );
};

export default Review;
